export default "__VITE_PUBLIC_ASSET__3c428bfd__"